import { render, staticRenderFns } from "./baseBreadCrumb.vue?vue&type=template&id=5d87f042&scoped=true"
import script from "./baseBreadCrumb.vue?vue&type=script&lang=js"
export * from "./baseBreadCrumb.vue?vue&type=script&lang=js"
import style0 from "./baseBreadCrumb.vue?vue&type=style&index=0&id=5d87f042&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d87f042",
  null
  
)

export default component.exports